import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const tableCellStyle = { border: '1px solid #EBEBEB' };

export const ServiceTable = () => (
  <TableContainer>
    <Table>
      <TableHead>
        <TableRow style={{
              backgroundColor: 'rgb(0, 144, 229)',
            }}>
          <TableCell>
            &nbsp;
          </TableCell>
          <TableCell
            style={{
              color: '#FFF',
              fontSize: 20,
            }}
            align="center">
            Visibility
          </TableCell>
          <TableCell
            style={{
              color: '#FFF',
              fontSize: 20,
            }}
            align="center">
            Proficiency
          </TableCell>
          <TableCell
            style={{
              color: '#FFF',
              fontSize: 20,
            }}
            align="center">
            Advocacy
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
		<TableRow 
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell colSpan={4} className="tbl-title" style={{ color: 'rgb(0, 144, 229)' }}>
            INTRODUCTION
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Be listed among 2,800+ experts
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-desc">
            Announce you to 1,700+ journalists
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Inclusion in our journalist “Story Ideas” page
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-desc">
            Introduction to Healthcare MNCs
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Introduction to Medical Podcasters
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
        <TableRow 
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell colSpan={4} className="tbl-title" style={{ color: 'rgb(0, 144, 229)' }}>
            PRODUCTION
          </TableCell>
        </TableRow>
        <TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            On-camera audition video (up to 60s, YouTube Shorts style) to promote you to journalists
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
        <TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-desc">
            On-camera BackgroundBriefing video interview
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center" style={{ color: 'rgb(0, 144, 229)', fontWeight: 'bold' }}>
            one (1)
          </TableCell>
          <TableCell
            align="center" style={{ color: 'rgb(0, 144, 229)', fontWeight: 'bold' }}>
            four (4)
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Messaging workshop to prepare for interviews
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-desc">
            Commercial/feature headshot photo
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Customised autograph card
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-desc">
            News releases in which you are the designated spokesperson
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Show reel you can publish on your social channels, and which we use to promote you to journalists
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center" style={{ color: 'rgb(0, 144, 229)', fontWeight: 'bold' }}>
            4/year
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-desc">
            Recording of your public speaking engagements
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Media Training for Healthcare Professionals
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-desc">
            Remove ContactsBook.Asia watermark from videos
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow 
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell colSpan={4} className="tbl-title" style={{ color: 'rgb(0, 144, 229)' }}>
            PROMOTION
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Be nominated for the Media Savvy Awards for your media and public speaking engagements
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-desc">
            Leads for free speaking engagements with corporates
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Negotiate professional speaker fees on your behalf for paid events
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-desc">
            Media monitoring
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Publish your articles on BackgoundBriefing.info
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-desc">
            Polish your LinkedIn profile/YouTube channel
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#e9f6fe',
            }}>
          <TableCell className="tbl-desc">
            Guaranteed content distribution to global media organisations
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell className="tbl-tick"
            align="center">
            ✔
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFFFFF',
            }}>
          <TableCell className="tbl-desc">
            Promotion of content through Dianomi business publisher network
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center">
            &nbsp;
          </TableCell>
          <TableCell
            align="center" style={{ color: 'rgb(0, 144, 229)', fontWeight: 'bold' }}>
            S$500 credit
          </TableCell>
        </TableRow>
		<TableRow
            style={{
              backgroundColor: '#FFF',
            }}>
          <TableCell className="tbl-title" style={{ color: 'rgb(0, 144, 229)' }}>
            TOTAL ANNUAL FEE (before GST)
          </TableCell>
          <TableCell
            align="center" style={{ color: 'rgb(0, 144, 229)', fontWeight: 'bold' }}>
            S$240
          </TableCell>
          <TableCell
            align="center" style={{ color: 'rgb(0, 144, 229)', fontWeight: 'bold' }}>
            S$4,560
          </TableCell>
          <TableCell
            align="center" style={{ color: 'rgb(0, 144, 229)', fontWeight: 'bold' }}>
            S$14,400
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
);
